import { useToastContext } from "../components/ui/toast/ToastProvider";

export default function useToast() {
  const { showToast } = useToastContext();

  /**
   * SUCCESS
   */
  const success = (title, message) => {
    showToast({
      type: "success",
      title,
      message,
    });
  };

  /**
   * ERROR
   */
  const error = (title, message) => {
    showToast({
      type: "error",
      title,
      message,
    });
  };

  /**
   * WARNING
   */
  const warning = (title, message) => {
    showToast({
      type: "warning",
      title,
      message,
    });
  };

  /**
   * INFO
   */
  const info = (title, message) => {
    showToast({
      type: "info",
      title,
      message,
    });
  };

  return {
    success,
    error,
    warning,
    info,
  };
}
